import React from 'react';
import { SWRConfig as SWR } from 'swr';
import { useNotificationContext } from '../NotificationContext';
import PreloadApi from './PreloadApi';

const SWRConfig = ({ children }: React.PropsWithChildren) => {
    const { showFailToaster } = useNotificationContext();
    return (
        <SWR
            value={{
                revalidateOnFocus: false,
                revalidateOnMount: true,
                onError: () => showFailToaster(),
            }}
        >
            <PreloadApi>{children}</PreloadApi>
        </SWR>
    );
};

export default SWRConfig;
